/* eslint-disable import/extensions */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
/* eslint-disable semi-style */
/* eslint-disable wrap-iife */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable eol-last */
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import '@popperjs/core/dist/umd/popper.min.js'
import './src/styles/global.scss'

// LinkedIn Insight Tag
if (typeof window !== 'undefined') {
  window._linkedin_partner_id = '7436364'
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []
  window._linkedin_data_partner_ids.push(window._linkedin_partner_id)
  ;(function (l) {
    if (!l) {
      window.lintrk = function (a, b) {
        window.lintrk.q.push([a, b])
      }
      window.lintrk.q = []
    }
    var s = document.getElementsByTagName('script')[0]
    var b = document.createElement('script')
    b.type = 'text/javascript'
    b.async = true
    b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js'
    s.parentNode.insertBefore(b, s)
  })(window.lintrk)
}

export const onRouteUpdate = () => {}

export const onClientEntry = () => {
  const prefetchOnHover = (e) => {
    const a = e.target.closest('a[href^="/"]')
    if (!a || a.getAttribute('target') === '_blank') return
    const href = a.getAttribute('href')
    if (!href || href === '#') return
    const pathname = href.split('?')[0].split('#')[0] || '/'
    if (window.___loader && window.___loader.hovering) {
      window.___loader.hovering(pathname)
    }
  }
  document.addEventListener('mouseover', prefetchOnHover, { passive: true })
}
